import script from "./MenuDesplegable.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDesplegable.vue?vue&type=script&setup=true&lang=js"

import "./MenuDesplegable.vue?vue&type=style&index=0&id=1de45ecb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de45ecb"]])

export default __exports__